const OverlayType = Object.freeze({
  CIRCLE: "CIRCLE",
  RECTANGLE: "RECTANGLE",
  POLYGON: "POLYGON",
  POLYLINE: "POLYLINE",
  MARKER: "MARKER",
  CUSTOM: "CUSTOM"
});
export default OverlayType;